import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ApiService } from 'src/app/core/service/api.service';
import { ConfigService } from 'src/app/core/service/config.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiMainAuctionService {
  constructor(private apiService: ApiService) { }


  GetMainAuctionDetailes(id: string) {
    return this.apiService
      .get(`${environment.apiUrl}auction/rooms/${id}`)
      .pipe(catchError(this.handleError));
  }


  handleError(error: any) {
    return throwError(error);
  }
}
